export default __webpack_public_path__ + "static/media/img-prof.585b1869.jpg";